export default __webpack_public_path__ + "static/media/38_Vyr_velky_PELZ_upr.d5375579.mp3";